//@ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
// import * as Sentry from '@sentry/react';
// import { Integrations } from '@sentry/tracing';

import reportWebVitals from 'reportWebVitals';

import App from 'App';
import ErrorBoundary from 'features/errors/ErrorBoundary';

// const { REACT_APP_SENTRY_DSN } = process.env;
// const { REACT_APP_ENVIRONMENT } = process.env;

// Sentry.init({
//   dsn: REACT_APP_SENTRY_DSN,
//   integrations: [new Integrations.BrowserTracing()],
//   tracesSampleRate: 1.0,
//   environment: REACT_APP_ENVIRONMENT,
//   //   release: '0.1.0',
// });

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
